export default __webpack_public_path__ + "static/media/restauration.6e42b398.webp";